import { Component, EventEmitter, Injector, OnInit, Output, ViewChild } from '@angular/core';
import { DataService } from '@app/shared/common/auth/data.service';
import { AppComponentBase } from '@shared/common/app-component-base';
import { UserServiceProxy } from '@shared/service-proxies/service-proxies';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'vf-subscription-adjust-users-modal',
  templateUrl: './subscription-adjust-users-modal.component.html'
})
export class SubscriptionAdjustUsersModalComponent extends AppComponentBase implements OnInit {

  @ViewChild('subscriptionAdjustUsersModal') modal: ModalDirective;
  @Output() openBillingDetailsEmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() openSBillingDetail: EventEmitter<any> = new EventEmitter<any>();
  planName = '';
  isFromBanner = false;
  maxUsers = 4;
  prodIdx = 0;
  selectedPlanId = 0;
  isShowReduceUsers = false;
  noOfUsers = 0;
  users: Array<any> = new Array<any>();
  productDetail: any;
  isSaving = false;

  constructor(injector: Injector,
    private dataService: DataService,
    private _userService: UserServiceProxy
  ) {
    super(injector);
  }

  ngOnInit() {
  }

  show(data) {
    this.isShowReduceUsers = false;
    if (data) {
      if (data[0] && data[0].length > 0) {
        this.productDetail = data[0];
      }
      if (data[1] === 0) {
        this.selectedPlanId = 0;
        let idx = data[0].findIndex(x => x.interval === 'year');
        this.prodIdx = idx;
        this.maxUsers = 50;
      } else {
        this.selectedPlanId = 1;
        let idx = data[0].findIndex(x => x.interval === 'month');
        this.prodIdx = idx;
        this.maxUsers = 4;
      }
      if (data[2]) {
        this.isFromBanner = data[2];
      }
      this.planName = data[0][this.prodIdx].name;
      this.getAllActiveUsers();
    }
    this.modal.show();
  }

  close() {
    if (this.modal.isShown) {
      this.modal.hide();
      this.isShowReduceUsers = false;
    }
  }

  closeBeforeActions() {
    if (this.modal.isShown) {
      this.dataService.showSubTrialEndModal.next();
      this.modal.hide();
      this.isShowReduceUsers = false;
    }
  }

  getAllActiveUsers() {
    this._userService.getTenantUsers().subscribe((result) => {
      if (!result.isError) {
        this.users = result.responseData;
        this.countActiveUsers();
      }
    });
    // this.users = [
    //   { id: 1, name: 'User 1', email: 'jason@trovve.com' },
    //   { id: 1, name: 'User Two', email: 'nirav@trovve.com' },
    //   { id: 1, name: 'User 3', email: 'jon@trovve.comjon@trovve.comjon@trovve.comjon@trovve.comjon@trovve.com' },
    //   { id: 1, name: 'User Four', email: 'nikunj@trovve.com' }
    // ];
  }

  reduceUsers() {
    this.isShowReduceUsers = true;
  }

  saveAdjustedUsers() {
    this.isSaving = true;
    let idsToDelete = this.users.filter(x => x.isDeleted).map(x => x.userId);
    this._userService.deleteMultipleUsers(this.appSession.userId, idsToDelete).subscribe((result) => {
      if (!result.isError) {
        let options = this.toastrOptions;
        this.toastr.success('Users deleted successfully', null, options);
        this.isSaving = false;
        // Update noOfUsers in productDetail to reflect the new active user count
        if (this.productDetail) {
          this.productDetail.forEach(p => {
            p.noOfUsers = this.noOfUsers;
          });
        }
        this.openBillingDetails();
      }
    });
  }

  hideReduceUsers() {
    this.isShowReduceUsers = false;
  }

  switchToProPlan() {
    this.selectedPlanId = 0;
    this.openBillingDetails();
  }

  openBillingDetails() {
    if (!this.isFromBanner) {
      this.openBillingDetailsEmit.emit([this.productDetail, this.selectedPlanId, this.isFromBanner]);
    } else {
      this.openSBillingDetail.emit([this.productDetail, this.selectedPlanId, this.isFromBanner]);
    }
    this.close();
  }

  openUrl(url: string) {
    window.open(url, '_blank');
  }

  removeUser(user) {
    user.isDeleted = true;
    this.countActiveUsers();
  }

  countActiveUsers() {
    if (this.users) {
      this.noOfUsers = this.users.filter(x => !x.isDeleted).length;
    }
  }
}
